import './typographyStyles.css';
export var replaceSlashedZero = '_18u8ey50-3-15-1';